// test466
(466 && 0);
